export default {
    apiKey: "AIzaSyBO7WGWXlb8qS5JnKW99V8IPjF-o8yggiM",
    authDomain: "ltkydr.firebaseapp.com",
    databaseURL: "https://ltkydr.firebaseio.com",
    projectId: "ltkydr",
    storageBucket: "ltkydr.appspot.com",
    messagingSenderId: "384041404851",
    appId: "1:384041404851:web:a01a1af0c08eef8aa263c6",
    measurementId: "G-0N72BYERYD"
};



// WEBPACK FOOTER //
// ./src/firebaseConfig.js